jQuery(function ($) {
        if ($('.boughto.boughto_wheel_results').length) {

            var current_request = false;
            getResults();

            function getResults(filters = {}) {
                if (current_request) {
                    return;
                }

                current_request = true;

                $.each(filters, function (key, value) {
                    if (Array.isArray(value)) {
                        new_value = "";
                        $.each(value, function (id, name) {
                            if (new_value != "") {
                                new_value += ',';
                            }
                            new_value += name;
                        });
                        filters[key] = new_value;
                    }
                });

                $('.default_filters').each(function () {
                    if (filters[$(this).attr('name')] === undefined) {
                        filters[$(this).attr('name')] = $(this).val();
                    }
                });

                updateUrlPrams(filters);

                filters['action'] = 'post_get_wheel_results';

                jQuery.ajax({
                    url: boughto.ajax_url,
                    type: 'post',
                    data: filters,
                    dataType: 'json',
                    beforeSend: function () {
                        $('.loading').show();
                    },
                    success: function (response) {

                        if (response.hasOwnProperty('data')) {
                            response = response.data;

                            // results
                            $('.boughto_results_wheels').html(response.results_html);
                            $('.lazy').Lazy({chainable: false});

                            // pagination
                            $('.boughto_results_pagination').html(response.pagination_html);


                            // filters
                            $.each(response.filters, function (name, data) {
                                mobileHtml = desktopHtml = selectHtml = '';

                                if(data.data.options.length === 0) {
                                    selectHtml += '<option selected value="">' + capitalizeFirstLetter(data.name) + '</option>';
                                }

                                $.each(data.data.options, function (key, filter) {
                                    let value = filter.key;

                                    if (filter.value !== undefined) {
                                        value = filter.value;
                                    }

                                    checked = "";
                                    selected = "";
                                    if (data.data.selected + "" === value + "") {
                                        checked = "checked";
                                        selected = "selected";
                                    }

                                    if (selectHtml === "") {
                                        selectHtml += '<option ' + selected + ' value="">' + capitalizeFirstLetter(data.name) + '</option>';
                                    }

                                    if (filter.key !== "All") {
                                        selectHtml += '<option ' + selected + ' value="' + value + '">' + filter.key + '</option>';
                                    }

                                    desktopHtml += '<div class="flex items-center">' +
                                        '<input ' + checked + ' id="filter-' + data.name + '-' + filter.key + '" name="' + data.name + '" value="' + value + '" type="' + data.type + '" class="h-4 w-4 border-gray-300 rounded text-boughto_primary_action_hex focus:ring-boughto_primary_action_hex">' +
                                        '<label for="filter-' + data.name + '-' + filter.key + '" class="ml-3 text-sm text-gray-600">' + filter.key + '</label></div>';

                                    mobileHtml += '<div class="flex items-center">' +
                                        '<input ' + checked + ' id="filter-m-' + data.name + '-' + filter.key + '"  name="' + data.name + '" value="' + value + '" type="' + data.type + '"  class="h-4 w-4 border-gray-300 rounded text-boughto_primary_action_hex focus:ring-boughto_primary_action_hex">' +
                                        '<label for="filter-m-' + data.name + '-' + filter.key + '" class="ml-3 min-w-0 flex-1 text-gray-500">' + filter.key + '</label></div>'

                                });

                                $('.' + data.class + '_select').html(selectHtml);
                                $('.' + data.class + '_desktop').html(desktopHtml);
                                $('.' + data.class + '_mobile').html(mobileHtml);
                            });


                            checkFiltersChanged();
                        } else {
                            // var ret = "<option value='-1'>No " + model.data("name") + " Found</option>";
                            // model.html(ret);
                        }

                        $('.loading').show();
                        current_request = false;
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        $('.loading').hide();
                        current_request = false;

                        // var ret = "<option value='-1'>Error Loading " + model.data("name") + "!</option>";
                        // model.html(ret);
                    }
                });
            }

            function updateUrlPrams(filters) {
                const url = new URL(window.document.URL);
                $.each(filters, function (key, value) {
                    url.searchParams.set(key, value);
                });

                window.history.replaceState(null, "", url.toString());
            }

            function checkFiltersChanged() {
                $('.boughto_wheel_results').each(function () {
                    var $self = $(this);

                    $self.find('.boughto_sort_button').click(function () {
                        $self.find('form.boughto_results_filters').each(function () {
                            updateForm($(this))
                        });
                    })

                    $self.find('form.boughto_results_filters').each(function () {
                        var $form = $(this);
                        var filters = 'input[name="diameter"], select[name="diameters"],input[name="width"], select[name="width"], select[name="offset"], input[name="offset"], input[name="brand"], select[name="brands"], input[name="design"], select[name="designs"], input[name="colour"], select[name="colour"], input[name="style"], select[name="style"]';

                        $form.find(filters).unbind();
                        $form.find(filters).change(function () {
                            updateForm($form)
                        });
                    });
                });
            }

            function updateForm($form) {
                var diameters = $form.find('input[name="diameter"]:checked, select[name="diameters"] option:selected'),
                    brands = $form.find('input[name="brand"]:checked, select[name="brands"] option:selected'),
                    designs = $form.find('input[name="design"]:checked, select[name="designs"] option:selected'),
                    widths = $form.find('input[name="width"]:checked, select[name="width"] option:selected'),
                    offsets = $form.find('input[name="offset"]:checked, select[name="offset"] option:selected'),
                    colour = $form.find('input[name="colour"]:checked, select[name="colour"] option:selected'),
                    style = $form.find('input[name="style"]:checked, select[name="style"] option:selected');

                getResults({
                    diameter: diameters.map(function () {
                        return $(this).val();
                    }).get(),
                    width: widths.map(function () {
                        return $(this).val();
                    }).get(),
                    offset: offsets.map(function () {
                        return $(this).val();
                    }).get(),
                    brand: brands.map(function () {
                        return $(this).val();
                    }).get(),
                    design: designs.map(function () {
                        return $(this).val();
                    }).get(),
                    colour: colour.map(function () {
                        return $(this).val();
                    }).get(),
                    style: style.map(function () {
                        return $(this).val();
                    }).get(),
                });
            }

            function capitalizeFirstLetter(string) {
                return string[0].toUpperCase() + string.slice(1);
            }
        }
    }
);